import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY = { name: "", email: "", organization: "", message: "" };

const Field = ({ label, name, value, onChange, type = "text", area = false, required = true }) => {
  const Tag = area ? "textarea" : "input";
  return (
    <label className="block">
      <span className="text-xs font-medium uppercase tracking-[0.18em] text-muted-ink">{label}</span>
      <Tag
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        required={required}
        rows={area ? 4 : undefined}
        data-testid={`contact-input-${name}`}
        className="mt-2 w-full resize-none border-b border-ink/20 bg-transparent pb-3 text-base text-ink outline-none transition-colors duration-300 placeholder:text-ink/30 focus:border-terra"
      />
    </label>
  );
};

export const ContactForm = ({ f }) => {
  const [data, setData] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const onChange = (e) => setData({ ...data, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/contact`, data);
      toast.success(f.success);
      setData(EMPTY);
    } catch {
      toast.error(f.error);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="contact-form" className="space-y-7 rounded-[28px] border border-ink/10 bg-white p-7 sm:p-10">
      <h3 className="font-serif text-3xl text-ink">{f.title}</h3>
      <div className="grid grid-cols-1 gap-7 sm:grid-cols-2">
        <Field label={f.name} name="name" value={data.name} onChange={onChange} />
        <Field label={f.email} name="email" type="email" value={data.email} onChange={onChange} />
      </div>
      <Field label={f.org} name="organization" value={data.organization} onChange={onChange} required={false} />
      <Field label={f.message} name="message" value={data.message} onChange={onChange} area />
      <button type="submit" disabled={busy} data-testid="contact-submit-btn" className="btn-ink group inline-flex w-full items-center justify-center gap-2.5 sm:w-auto">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
        {busy ? f.sending : f.send}
        {!busy && <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />}
      </button>
    </form>
  );
};
